import React from "react";
import {
  Document,
  Page,
  Image,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import QRCode from "qrcode";

const styles = StyleSheet.create({
  page: {},
  view: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
  },
  qrContainer: {
    width: 80,
    minHeight: 80,
  },
  qrImage: {
    width: 80,
    height: 80,
    objectFit: "contain",
  },
  qrCode: {
    fontSize: 5,
    fontFamily: "Courier",
    textAlign: "left",
    width: "100%",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
    wordBreak: "break-all",
  },
  detailsContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "top",
    gap: 3,
    paddingTop: 10,
  },
  productId: {
    fontSize: 8,
    fontWeight: "bold",
    paddingTop: 8,
  },
  productName: {
    fontSize: 8,
    fontWeight: "bold",
  },
  variantInfo: {
    fontSize: 8,
    color: "#4B5563",
  },
  price: {
    fontSize: 8,
    color: "#4B5563",
    marginTop: 2,
  },
});

const QRCodePage = ({ product }) => {
  const generateQRCode = async (product) => {
    try {
      let url = await QRCode.toDataURL(JSON.stringify(product?.qr_code));
      return url;
    } catch (error) {
      console.log("Error generating QRCode : ", error);
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <Page size={[200, 80]} style={styles.page}>
      <View key={`view_${product?.id}`} style={styles.view}>
        <View style={styles.qrContainer}>
          <Image src={generateQRCode(product)} style={styles.qrImage} />
        </View>
        <View style={styles.detailsContainer}>
          <Text style={styles.qrCode}>
            {product?.qr_code.substring(0, 18)}
            {product?.qr_code.substring(18, 36)}
          </Text>
          <Text style={styles.productName}>
            {product?.product_detail?.name}
          </Text>
          <Text style={styles.variantInfo}>
            {product?.id} - {product?.color?.name} - {product?.size?.name}
          </Text>
          <Text style={styles.price}>
            {formatPrice(product?.product_detail?.price)}
          </Text>
        </View>
      </View>
    </Page>
  );
};

const QRCodeDocument = ({ products }) => {
  console.log("Product: ", products);
  return (
    <Document>
      {Array.isArray(products) ? (
        products?.map((product) => <QRCodePage product={product} />)
      ) : (
        <QRCodePage product={products} />
      )}
    </Document>
  );
};

export default QRCodeDocument;
